module.exports = __webpack_public_path__ + "img/social_banner.7133ee85.png";